export default __webpack_public_path__ + "static/media/g5.14421c93.png";